import { render, staticRenderFns } from "./Partenaires.vue?vue&type=template&id=80e01014&scoped=true&"
import script from "./Partenaires.vue?vue&type=script&lang=ts&"
export * from "./Partenaires.vue?vue&type=script&lang=ts&"
import style0 from "./Partenaires.vue?vue&type=style&index=0&id=80e01014&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80e01014",
  null
  
)

export default component.exports